import React, { ReactNode } from 'react';
import Box from '@rexlabs/box';
import { StyleSheet, useStyles } from '@rexlabs/styling';
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaPinterest,
  FaYoutube
} from '@meronex/icons/fa';
import TwitterX from './twitter-x.svg';

const defaultStyles = StyleSheet({
  iconsRow: {
    '> a': {
      cursor: 'pointer',
      width: '18px',
      opacity: 1,
      margin: '0px 12px 0px 12px',
      transition: 'all .3s',
      ':hover': {
        color: 'var(--menu_font_hover_color)',
        opacity: 0.7
      }
    },
    '> a:first-child': {
      marginLeft: 0
    },
    '> a:last-child': {
      marginRight: 0
    },
    '> a > svg': {
      width: '18px',
      height: 'auto',
      'stroke-width': '10'
    }
  }
});

type SocialLinks = {
  facebook?: string | boolean;
  instagram?: string | boolean;
  twitter?: string | boolean;
  linkedin?: string | boolean;
  pinterest?: string | boolean;
  youtube?: string | boolean;
};

interface Props {
  overrideColor: string;
  socialLinks: SocialLinks;
  menuFontHoverColor: string;
}

const socialIcons: { [key: string]: ReactNode } = {
  facebook: FaFacebook({}),
  instagram: FaInstagram({}),
  twitter: <TwitterX />,
  linkedin: FaLinkedin({}),
  pinterest: FaPinterest({}),
  youtube: FaYoutube({})
};

export function SocialContactsTS(props: Props) {
  const { overrideColor, socialLinks } = props;
  const s = useStyles(defaultStyles);

  // Replace the http:// (or any other protocol) prefix from a URL to the format //[url]
  const cleanURL = (url: string) =>
    `//${url.toString().replace(/(^\w+:|^)\/\//, '')}`;

  const socials = Object.keys(socialLinks)
    .map((key) => ({
      name: key,
      link: socialLinks[key as keyof SocialLinks]
    }))
    .filter((i) => i.link !== false);

  return (
    <Box
      flex={1}
      flexDirection={'row'}
      alignItems={'center'}
      {...s.with('iconsRow')({
        color: overrideColor
      })}
    >
      {socials.map((item, idx) => {
        return (
          <a
            key={idx}
            aria-label={item.name}
            rel={'noreferrer'}
            href={cleanURL(item.link?.toString() ?? '')}
            target='_blank'
          >
            {socialIcons[item.name]}
          </a>
        );
      })}
    </Box>
  );
}
